import { Address } from 'types/address';

export type AddressErrors = Partial<
  Record<'zip_code' | 'street' | 'street_number' | 'neighborhood' | 'city' | 'state', string>
>;

export const emptyAddress: Address = {
  id: 0,
  zip_code: '',
  street: '',
  street_number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
};

const FIELDS: (keyof Address)[] = [
  'zip_code',
  'street',
  'street_number',
  'complement',
  'neighborhood',
  'city',
  'state',
];

export function isAddressFilled(address: Address | null): boolean {
  return !!address && FIELDS.some(field => String(address[field] ?? '').trim() !== '');
}

// Endereço vazio é válido (paciente sem endereço); preenchido exige CEP e os campos que a API obriga.
export function validateAddress(address: Address | null): AddressErrors {
  if (!address || !isAddressFilled(address)) return {};

  if (address.zip_code.replace(/\D/g, '').length !== 8) {
    return { zip_code: 'Informe o CEP para salvar o endereço' };
  }

  const errors: AddressErrors = {};
  if (!address.street.trim()) errors.street = 'Informe a rua';
  if (!address.street_number.trim()) errors.street_number = 'Informe o número ou marque sem número';
  if (!address.neighborhood.trim()) errors.neighborhood = 'Informe o bairro';
  if (!address.city.trim()) errors.city = 'Informe a cidade';
  if (!address.state.trim()) errors.state = 'Informe a UF';

  return errors;
}
